import React from 'react';
import { withTranslation } from 'react-i18next';
import {
  FormWrapper,
  RFFormInput,
  RFFormRadioGroup,
  RFFormCheckbox,
  RFFormTextarea,
} from 'virtues-bootstrap';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import AdaptiveDataRow from 'components/DataBlock/AdaptiveDataRow';

import DurationPicker from './DurationPicker';

import s from '../styles.module.scss';

const EndFields = ({
  disabled,
  isAnyVentricularArrhythmiasDetectedOpen,
  isAnyAtrialArrhythmiasDetectedOpen,
  t,
  leadsPresent,
  handleAtrialPresentLeadClick,
  formName,
  userRole,
}) => (
  <FormWrapper className={s.deviceStatus}>
    <AdaptiveDataRow
      className={s.marginBottom}
      withLabelMargin
      title={t('detailedEPReport.atrialLeadsPresent')}
    >
      <Field
        onClick={handleAtrialPresentLeadClick(formName)}
        component={RFFormCheckbox}
        name="leadsPresent"
        disabled={disabled}
      />
    </AdaptiveDataRow>
    <AdaptiveDataRow
      className={s.noMargin}
      withLabelMargin
      title={t('detailedEPReport.percentAtrialPacing')}
    >
      <Field
        disabled={disabled || !leadsPresent}
        component={RFFormInput}
        name="percentAtrialPacing"
      />
    </AdaptiveDataRow>
    <AdaptiveDataRow
      className={s.noMargin}
      withLabelMargin
      title={t('detailedEPReport.percentVentricularPacing')}
    >
      <Field disabled={disabled} component={RFFormInput} name="percentVentricularPacing" />
    </AdaptiveDataRow>

    <AdaptiveDataRow title={t('detailedEPReport.anyVentricularArrhythmiasDetected')}>
      <RFFormRadioGroup
        groupName="anyVentricularArrhythmiasDetected"
        radioButtons={[
          { disabled, label: t('yes'), value: 'Yes' },
          { disabled, label: t('no'), value: 'No' },
        ]}
        inline
      />
    </AdaptiveDataRow>

    {isAnyVentricularArrhythmiasDetectedOpen && (
      <div className={s.subFieldsBlock}>
        <AdaptiveDataRow
          className={s.noMargin}
          withLabelMargin
          title={t('detailedEPReport.mostRecentDate')}
        >
          <Field
            disabled={disabled}
            component={RFFormInput}
            name="anyVentricularArrhythmiasDetectedDate"
          />
        </AdaptiveDataRow>
        <AdaptiveDataRow
          className={s.noMargin}
          withLabelMargin
          title={t('detailedEPReport.mostRecentRate')}
        >
          <Field
            disabled={disabled}
            component={RFFormInput}
            name="anyVentricularArrhythmiasDetectedRate"
          />
        </AdaptiveDataRow>
        <AdaptiveDataRow
          className={s.noMargin}
          withLabelMargin
          title={t('detailedEPReport.treatment')}
        >
          <Field
            disabled={disabled}
            component={RFFormTextarea}
            name="anyVentricularArrhythmiasDetectedTreatment"
          />
        </AdaptiveDataRow>
      </div>
    )}

    <AdaptiveDataRow title={t('detailedEPReport.anyAtrialArrhythmiasDetected')}>
      <RFFormRadioGroup
        groupName="anyAtrialArrhythmiasDetected"
        radioButtons={[
          { disabled, label: t('yes'), value: 'Yes' },
          { disabled, label: t('no'), value: 'No' },
        ]}
        inline
      />
    </AdaptiveDataRow>
    {isAnyAtrialArrhythmiasDetectedOpen && (
      <div className={s.subFieldsBlock}>
        <AdaptiveDataRow
          className={s.noMargin}
          withLabelMargin
          title={t('detailedEPReport.mostRecentDate')}
        >
          <Field
            disabled={disabled}
            component={RFFormInput}
            name="anyAtrialArrhythmiasDetectedDate"
          />
        </AdaptiveDataRow>
        <AdaptiveDataRow
          className={s.noMargin}
          withLabelMargin
          title={t('detailedEPReport.mostRecentAttrialRate')}
        >
          <Field
            disabled={disabled}
            component={RFFormInput}
            name="anyAtrialArrhythmiasDetectedRate"
          />
        </AdaptiveDataRow>
        <AdaptiveDataRow
          className={s.noMargin}
          withLabelMargin
          title={t('detailedEPReport.lengthOfTime')}
        >
          <Field
            disabled={disabled}
            component={DurationPicker}
            name="anyAtrialArrhythmiasDetectedTimeLength"
          />
        </AdaptiveDataRow>
      </div>
    )}
    {userRole === 'DT' && (
      <>
        <AdaptiveDataRow title={t('patient.deviceStatus')}>
          <Field
            component={RFFormTextarea}
            label={t('reports.patientInstructions')} // patient instructions
            maxLength={1000}
            name="device_status_notes"
            rows={4}
          />
          <Field
            component={RFFormTextarea}
            label={t('reports.recommendationsForPhysician')} // device report findings
            maxLength={1000}
            name="device_status_recommendations"
            rows={4}
          />
        </AdaptiveDataRow>
        <AdaptiveDataRow title={t('reports.guidelineDirectedMedicalTherapy')}>
          <Field
            component={RFFormTextarea}
            label={t('reports.comments')}
            maxLength={1000}
            name="comments"
            rows={5}
          />
        </AdaptiveDataRow>
      </>
    )}
  </FormWrapper>
);

EndFields.propTypes = {
  t: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isAnyAtrialArrhythmiasDetectedOpen: PropTypes.bool,
  isAnyVentricularArrhythmiasDetectedOpen: PropTypes.bool,
  leadsPresent: PropTypes.bool,
  handleAtrialPresentLeadClick: PropTypes.func.isRequired,
  formName: PropTypes.string.isRequired,
  userRole: PropTypes.string.isRequired,
};

EndFields.defaultProps = {
  disabled: false,
  isAnyVentricularArrhythmiasDetectedOpen: false,
  isAnyAtrialArrhythmiasDetectedOpen: false,
  leadsPresent: false,
};

export default withTranslation()(EndFields);
